// extracted by mini-css-extract-plugin
export default {"btnOps":"ButtonOps_btnOps__451+d"};